import { Get, Remove, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/category/store",
    data: data,
  });
};

export const GetData = async (pageNumber, limit = 15) => {
  return await Get({
    url: "/category/show_all",
    data: {
      limit: limit,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const DeleteData = async data => {
  await Remove({
    url: "/category/destroy",
    data: data,
  });
};

export const EditData = async data => {
  await Set({
    url: "/category/update",
    data: data,
  });
};
